export default "__VITE_ASSET__DJ1LI4W7__"